var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconQrCodeTimes = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30" },
            React.createElement("rect", { x: "26", y: "12.5", width: "1.5", height: "2.5" }),
            React.createElement("rect", { x: "2.5", y: "10", width: "1.5", height: "2.5" }),
            React.createElement("rect", { x: "2.5", y: "17.5", width: "1.5", height: "5" }),
            React.createElement("rect", { x: "15", y: "26", width: "4.8", height: "1.5" }),
            React.createElement("rect", { x: "2.5", y: "26", width: "10", height: "1.5" }),
            React.createElement("rect", { x: "20", y: "2.5", width: "4", height: "1.5" }),
            React.createElement("rect", { x: "2.5", y: "6", width: "1.5", height: "1.5" }),
            React.createElement("rect", { x: "10", y: "2.5", width: "2.5", height: "1.5" }),
            React.createElement("rect", { x: "15", y: "2.5", width: "2.5", height: "1.5" }),
            React.createElement("rect", { x: "2.5", y: "2.5", width: "5", height: "1.5" }),
            React.createElement("rect", { x: "26", y: "17.5", width: "1.5", height: "10" }),
            React.createElement("rect", { x: "26", y: "2.5", width: "1.5", height: "7.5" }),
            React.createElement("g", null,
                React.createElement("path", { d: "M21,9L9,21" }),
                React.createElement("path", { d: "M9,9l12,12" })))));
});
export default IconQrCodeTimes;
//# sourceMappingURL=IconQrCodeTimes.js.map